import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Home from '../pages/home';
// import Login from '../pages/user/login';
import ChatDemo from '@/pages/chatDemo';
import Login from '@/pages/login';
import NoFind from '../pages/user/noFind';
import Password from '../pages/user/password';

// 懒加载只能针对挂载在Home组件下的组件，因为Suspense组件放在Home中
const Index = lazy(() => import('../pages/index'));
const ProjectDetail = lazy(() => import('../pages/projectDetail'));
const PatientList = lazy(() => import('../pages/patient/list'));
const PatientAdd = lazy(() => import('../pages/patient/add'));
const PatientDetail = lazy(() => import('../pages/patient/detail'));
const PatientHospitalMedical = lazy(() => import('../pages/patient/hospitalMedical'));
const PatientConsult = lazy(() => import('../pages/patient/consult'));
const PatientInfirmary = lazy(() => import('../pages/patient/infirmary'));
const OrganList = lazy(() => import('../pages/setting/organList'));
const UserList = lazy(() => import('../pages/setting/userList'));
const Department = lazy(() => import('../pages/setting/department'));
const LabelClassify = lazy(() => import('../pages/setting/labelClassify'));
const Role = lazy(() => import('../common/pages/customer/role/right'));
const Staff = lazy(() => import('../pages/setting/staff'));
const Message = lazy(() => import('../pages/notice/message'));
const SysMessage = lazy(() => import('../pages/notice/sysMessage'));
const MessageDetail = lazy(() => import('../pages/notice/messageDetail'));
const FollowList = lazy(() => import('../pages/follow/list'));
const ImportRecord = lazy(() => import('../pages/follow/importRecord'));
const FollowCount = lazy(() => import('../pages/follow/count'));
const PatientInvite = lazy(() => import('../pages/patient/invite'));
const EarlyWarning = lazy(() => import('../pages/patientService/earlyWarning/list'));
const TodoList = lazy(() => import('../pages/patientService/todoList/list'));
const FollowCountDetail = lazy(() => import('../pages/follow/countDetail'));
const FollowReportDetail = lazy(() => import('../pages/follow/reportDetail'));
const ProjectList = lazy(() => import('../pages/project/list'));
const ProjectListDetail = lazy(() => import('../pages/project/detail'));
const ChangePassword = lazy(() => import('../pages/personal/changePassword'));
const DataSettings = lazy(() => import('../pages/personal/dataSettings'));
const LoginRecord = lazy(() => import('../pages/personal/loginRecord'));
const AllCustom = lazy(() => import('../pages/weComManage/allCustom'));
const Empower = lazy(() => import('../pages/weComManage/empower'));
const PatientInfoExport = lazy(() => import('../pages/dataExport/patientInfoExport'));
const PatientInfoExportFieldDetail = lazy(
  () => import('../pages/dataExport/patientInfoExportFieldDetail'),
);
const ConsentExport = lazy(() => import('../pages/dataExport/consentExport'));
const FileExport = lazy(() => import('../pages/dataExport/fileExport'));
const ExportRecord = lazy(() => import('../pages/dataExport/exportRecord'));
const DrugRecordExport = lazy(() => import('../pages/dataExport/drugRecordExport'));
const QcWorkbench = lazy(() => import('../pages/qc/workbench'));
const QcWorkbenchDetail = lazy(() => import('../pages/qc/workbench/detail'));
const QcRecord = lazy(() => import('../pages/qc/record'));
const QcRecordDetail = lazy(() => import('../pages/qc/record/detail'));
const QcCalendar = lazy(() => import('../pages/qc/calendar'));
const QcGroup = lazy(() => import('../pages/qc/group'));
const QcReport = lazy(() => import('../pages/qc/report'));

export type routerConfigItem = {
  path: string;
  code?: string;
  element?: React.ReactNode;
  hideInMenu?: boolean;
  children?: routerConfigItem[];
  meta?: any;
};

export const baseRouterConfig: routerConfigItem[] = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/password',
    element: <Password />,
  },
  {
    path: '*',
    element: <NoFind />,
  },
];
const routerConfig: routerConfigItem[] = [
  {
    path: '/',
    element: <Home />,
    code: '',
    children: [
      {
        path: '/',
        element: <Navigate to="/index" replace />,
      },
      {
        path: 'index',
        element: <Index />,
        hideInMenu: true,
        code: 'Index',
      },
      {
        path: 'index/project-detail',
        element: <ProjectDetail />,
        hideInMenu: true,
        // code: 'ProjectDetail',
      },
      {
        path: '/message/applyMessage',
        element: <Message />,
        code: 'Message',
      },
      {
        path: '/message/sysMessage',
        element: <SysMessage />,
        code: 'SysMessage',
      },
      {
        path: '/message/applyMessage/detail',
        element: <MessageDetail />,
      },
      {
        path: '/patient/list',
        element: <PatientList />,
        code: 'PatientList',
      },
      {
        path: '/patient/add',
        element: <PatientAdd />,
        // code: 'PatientAdd',
      },
      {
        path: '/patient/detail',
        element: <PatientDetail />,
        // code: 'PatientDetail',
      },
      {
        path: '/patient/detail/hospital',
        element: <PatientHospitalMedical />,
      },
      {
        path: '/patient/detail/history',
        element: <PatientDetail isHistory={true} />,
        // code: 'PatientDetail',
      },
      {
        path: '/patient/consult',
        element: <PatientConsult />,
        code: 'PatientConsult',
      },
      {
        path: '/patient/invite',
        element: <PatientInvite />,
        code: 'PatientInvite',
      },
      {
        path: '/patient/infirmary',
        element: <PatientInfirmary />,
        code: 'PatientInfirmary',
      },
      // {
      //   path: '/setting/organList',
      //   element: <OrganList />,
      //   code: 'OrganList',
      // },
      // {
      //   path: '/setting/userList',
      //   element: <UserList />,
      //   code: 'UserList',
      // },
      // {
      //   path: '/setting/department',
      //   element: <Department />,
      //   code: 'Department',
      // },
      // {
      //   path: '/setting/staff',
      //   element: <Staff />,
      //   code: 'Staff',
      // },
      {
        path: '/setting/department',
        element: <Department />,
        code: 'DepartmentList',
      },
      {
        path: '/setting/employees',
        element: <Staff />,
        code: 'CustomerEmployeesList',
      },
      {
        path: '/setting/role',
        element: <Role independence />,
        code: 'HccmCustomerRole',
      },
      {
        path: '/setting/tag/classify',
        element: <LabelClassify />,
        code: 'HccmTagClassify',
      },
      {
        path: '/follow/list',
        element: <FollowList />,
        code: 'FollowList',
      },
      {
        path: '/follow/importRecord',
        element: <ImportRecord />,
        code: 'ImportRecord',
      },
      {
        path: '/follow/count',
        element: <FollowCount />,
        code: 'FollowCount',
      },
      {
        path: '/follow/count/detail',
        element: <FollowCountDetail />,
        // code: 'FollowCountDetail',
        hideInMenu: true,
      },
      {
        path: '/follow/report/detail',
        element: <FollowReportDetail />,
        hideInMenu: true,
      },
      {
        path: '/qc/workbench',
        element: <QcWorkbench />,
        code: 'QcWorkbench',
      },
      {
        path: '/qc/workbench/detail',
        element: <QcWorkbenchDetail />,
        hideInMenu: true,
      },
      {
        path: '/qc/record',
        element: <QcRecord />,
        code: 'QcRecord',
      },
      {
        path: '/qc/record/detail',
        element: <QcRecordDetail />,
        hideInMenu: true,
      },
      {
        path: '/qc/calendar',
        element: <QcCalendar />,
        code: 'QcCalendar',
      },
      {
        path: '/qc/group',
        element: <QcGroup />,
        code: 'QcGroup',
      },
      {
        path: '/qc/report',
        element: <QcReport />,
        code: 'QcReport',
      },
      {
        path: '/project/list',
        element: <ProjectList />,
        code: 'ProjectList',
      },
      {
        path: '/project/list/detail',
        element: <ProjectListDetail />,
        // code: 'ProjectListDetail',
      },
      {
        path: '/personal/changePassword',
        element: <ChangePassword />,
        code: 'ChangePassword',
      },
      {
        path: '/personal/dataSettings',
        element: <DataSettings />,
        code: 'DataSettings',
      },
      {
        path: '/personal/loginRecord',
        element: <LoginRecord />,
        code: 'LoginRecord',
      },
      {
        path: '/weComManage/allCustom',
        element: <AllCustom />,
        code: 'AllCustom',
      },
      {
        path: '/weComManage/empower',
        element: <Empower />,
        code: 'Empower',
      },
      {
        path: '/dataExport/consentExport',
        element: <ConsentExport />,
        code: 'ConsentExport',
      },
      {
        path: '/dataExport/fileExport',
        element: <FileExport />,
        code: 'FileExport',
      },
      {
        path: '/dataExport/infoExport',
        element: <PatientInfoExport />,
        code: 'PatientInfoExport',
      },
      {
        path: '/dataExport/infoExport/exportFieldDetail',
        element: <PatientInfoExportFieldDetail />,
      },
      {
        path: '/dataExport/record',
        element: <ExportRecord />,
        code: 'ExportRecord',
      },
      {
        path: '/dataExport/drugRecord',
        element: <DrugRecordExport />,
        code: 'DrugRecordExport',
      },
      {
        path: '/patientService/earlyWarning',
        element: <EarlyWarning />,
        code: 'EarlyWarning',
      },
      {
        path: '/patientService/todoList',
        element: <TodoList />,
        code: 'TodoList',
      },
    ],
  },
  {
    path: '/chatDemo',
    element: <ChatDemo />,
  },
  ...baseRouterConfig,
];

// todo: 与路由表结合生成面包屑地图数据
export const breadcrumbMap = {
  patient: {
    label: '患者管理',
    path: '/patient/list',
    list: {
      label: '管理列表',
      path: '/patient/list',
    },
    add: {
      label: '患者建档',
      path: '/patient/add',
    },
    consult: {
      label: '患者咨询',
      path: '/patient/consult',
    },
    invite: {
      label: '患者邀请',
      path: '/patient/invite',
    },
    infirmary: {
      label: '院内患者',
      path: '/patient/infirmary',
    },
  },
  patientService: {
    label: '患者服务',
    path: '/patientService/todoList',
    earlyWarning: {
      label: '预警管理',
      path: '/patientService/earlyWarning',
    },
    todoList: {
      label: '待办管理',
      path: '/patientService/todoList',
    },
  },
  setting: {
    label: '配置',
    path: '/setting/department',
    department: {
      label: '科室管理',
      path: '/setting/department',
    },
    employees: {
      label: '员工管理',
      path: '/setting/employees',
    },
  },
  weapp: {
    label: '小程序管理',
    path: '/weapp/column',
    column: {
      label: '平台栏目管理',
      path: '/weapp/column',
    },
    project: {
      label: '病种项目管理',
      path: '/weapp/project',
      add: {
        label: '新增病种项目',
        path: '/weapp/project/add',
      },
      edit: {
        label: '编辑病种项目',
        path: '/weapp/project/edit',
      },
    },
  },
  follow: {
    label: '跟进管理',
    path: '/follow/list',
    list: {
      label: '项目跟进列表',
      path: '/follow/list',
    },
    count: {
      label: '项目跟进统计',
      path: '/follow/count',
      add: {
        label: '新增病种项目',
        path: '/weapp/project/add',
      },
      edit: {
        label: '编辑病种项目',
        path: '/weapp/project/edit',
      },
      detail: {
        label: '管理项目汇总详情',
        path: '/follow/count/detail',
      },
    },
    report: {
      label: '项目跟进统计',
      path: '/follow/count',
      detail: {
        label: '患者报告汇总详情',
        path: '/follow/report/detail',
      },
    },
    importRecord: {
      label: '导入记录',
      path: '/follow/importRecord',
    },
  },
  qc: {
    label: 'QC审核',
    path: '/qc/workbench',
    workbench: {
      label: '审核工作台',
      path: '/qc/workbench',
      detail: {
        label: 'QC审核详情',
        path: '/qc/workbench/detail',
      },
    },
    record: {
      label: 'QC记录查询',
      path: '/qc/record',
      detail: {
        label: 'QC审核记录详情',
        path: '/qc/record/detail',
      },
    },
    calendar: {
      label: 'QC工作日历',
      path: '/qc/calendar',
    },
    group: {
      label: 'QC人员分组',
      path: '/qc/group',
    },
    report: {
      label: 'QC统计报表',
      path: '/qc/report',
    },
  },
  project: {
    label: '项目资料',
    path: '/project/list',
    list: {
      label: '项目资料库',
      path: '/project/list',
      detail: {
        label: '项目详情',
        path: '/project/list/detail',
      },
    },
  },
  personal: {
    label: '个人中心',
    path: '/personal/dataSettings',
    dataSettings: {
      label: '资料设置',
      path: '/project/dataSettings',
    },
    loginRecord: {
      label: '登录记录',
      path: '/project/loginRecord',
    },
    changePassword: {
      label: '修改密码',
      path: '/project/changePassword',
    },
  },
  message: {
    label: '消息通知',
    path: '/message/applyMessage',
    applyMessage: {
      label: '申请通知',
      path: '/message/applyMessage',
      detail: {
        label: '申请通知详情',
        path: '/message/applyMessage/detail',
      },
    },
    sysMessage: {
      label: '系统通知',
      path: '/message/sysMessage',
    },
  },
  weComManage: {
    label: '企微管理',
    path: '/weComManage/allCustom',
    allCustom: {
      label: '全部客户',
      path: '/weComManage/allCustom',
    },
    empower: {
      label: '企微授权',
      path: '/weComManage/empower',
    },
  },
  dataExport: {
    label: '数据导出',
    path: '/dataExport/consentExport',
    consentExport: {
      label: '知情同意书导出',
      path: '/dataExport/consentExport',
    },
    fileExport: {
      label: '上传资料图片导出',
      path: '/dataExport/fileExport',
    },
    infoExport: {
      label: '患者档案导出',
      path: '/dataExport/infoExport',
      exportFieldDetail: {
        label: '导出字段选择',
        path: '/dataExport/exportFieldDetail',
      },
    },
    drugRecord: {
      label: '用药记录导出',
      path: '/dataExport/drugRecord',
    },
    record: {
      label: '导出记录',
      path: '/dataExport/record',
    },
  },
};
function mapRouterConfig(config: routerConfigItem[], fn: any, parentPath = '') {
  config.forEach((item) => {
    fn && fn(item, parentPath);
    if (item.children) {
      const en = item.path.startsWith('/') || parentPath.endsWith('/') ? '' : '/';
      mapRouterConfig(item.children, fn, parentPath + en + item.path);
    }
  });
}
const hideInMenuPages: string[] = [];
mapRouterConfig(routerConfig, (router: routerConfigItem, parentPath: string) => {
  if (router.hideInMenu) {
    const en = router.path.startsWith('/') || parentPath.endsWith('/') ? '' : '/';
    hideInMenuPages.push(parentPath + en + router.path);
  }
});
export { hideInMenuPages };
export default routerConfig;
